import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * When the profile page updates Capium3 dbo.UserMaster (team PUT), the workspace navbar can subscribe
 * to refresh acting-user name/phone without a full reload.
 */
@Injectable({ providedIn: 'root' })
export class PmProfileDirectorySyncService {
  private readonly refresh$ = new Subject<void>();

  /** Subscribe in {@link PmWorkspaceComponent} to refetch the acting team row and update `profile()`. */
  readonly workspaceProfileRefresh$ = this.refresh$.asObservable();

  notifyDirectoryProfileSynced(): void {
    this.refresh$.next();
  }
}
